export default {
  STATUSES: {
    REGISTERED: 'registered',
    PENDING_APPROVAL: 'pending-approval',
    ACTIVE: 'active',
    INACTIVE: 'inactive',
  },
};
